import { createContext, useContext, type PropsWithChildren } from "react";
import type { AiModelApi } from "../data/AiModelApi";

const Context = createContext<AiModelApi | null>(null);

export function AiModelProvider({ api, children }: PropsWithChildren<{ api: AiModelApi }>) {
  return <Context.Provider value={api}>{children}</Context.Provider>;
}

export function useAiModelApi() {
  const value = useContext(Context);
  if (!value) throw new Error("useAiModelApi must be used within AiModelProvider");
  return value;
}
